import React,{ Component } from 'react';
import Route from 'react-router-dom/Route';
import Switch from 'react-router-dom/Switch';

import OnboardingTutorialSetup from '../../OnboardingTutorialSetup';
import GuidedCampaignCreation from '../../GuidedCampaignCreation';
import GuidedCampaignPayment from '../../GuidedCampaignPayment';
import GuidedCampaignReview from '../../GuidedCampaignReview';
import GuidedCampaignAudience from '../../GuidedCampaignAudience';
import TutorialLoadingScreen from '../../../shared/components/TutorialLoadingScreen';
import OnboardingHiImGreg from '../../OnboardingHiImGreg';


class OnboardingTutorial extends Component {
  constructor(){
    super();

    this.state = {
      isLoaded:false,
      error:null
    };
  }

  componentDidMount(){
    this.props.loadActiveUser()
      .then(() => {
        if(this.props.activeUser.isProvider){
          throw new Error('This is not a valid route for superadmins.  Please log in as regular user and continue.');
        }

        return;
      })
      .then(() => Promise.all([
        this.props.loadAgency(this.props.activeUser.agencyId),
        this.props.loadPaymentMethodsForAgency(this.props.activeUser.agencyId),
        this.props.loadBrandsForAgency(this.props.activeUser.agencyId)
      ]))
      .then(() => {
        if(this.props.match.params.campaignId){
          return Promise.all([
            this.props.loadCampaign(this.props.match.params.campaignId),
            this.props.loadEngagementsForCampaign(this.props.match.params.campaignId)
          ]);
        }else{
          return Promise.resolve();
        }
      })
      .then(() => this.setState({isLoaded:true}))
      .catch((err) => this.setState({error:err}));
  }

  render(){
    const { activeUser } = this.props;
    const { isLoaded, error } = this.state;

    if(activeUser && activeUser.isProvider){
      return (
        <TutorialLoadingScreen
          title='YOU ARE A SUPERADMIN GET OUT'
          subtitle='REEEEEEEEEEEEEEEEEEEEEEEEEEEEE'
        />
      )
    }

    if(error){
      console.log('GOT ERROR',error);
      return (
        <TutorialLoadingScreen
          title='An error has occurred'
          subtitle={error.message}
        />
      )
    }

    if(!isLoaded){
      return (
        <TutorialLoadingScreen
          title="Let's build an experience together!"
          subtitle=''
          showSpinner
        />
      )

    }

    return (
      <Switch>
        <Route exact path='/welcome/tutorial/setup' component={OnboardingTutorialSetup} />
        <Route exact path='/welcome/tutorial/success' component={OnboardingHiImGreg} />
        <Route 
          exact path='/welcome/tutorial/:campaignId/create' 
          render={(routeProps) => (
            <GuidedCampaignCreation 
              {...routeProps}
              isOnboarding
              allowingBrandEditingInline
              showSuperadminFeatures={false}
              backURL='/account/experiences'
              forwardURL={`/welcome/tutorial/${routeProps.match.params.campaignId}/audience`}
            />
          )}
        />
        <Route 
          exact path='/welcome/tutorial/:campaignId/audience' 
          render={(routeProps) => (
            <GuidedCampaignAudience 
              {...routeProps}
              isOnboarding
              showSuperadminFeatures={false}
              forwardURL={`/welcome/tutorial/${routeProps.match.params.campaignId}/payment`}
              backURL={`/welcome/tutorial/${routeProps.match.params.campaignId}/create`}
            />
          )}
        />
        <Route 
          exact path='/welcome/tutorial/:campaignId/payment' 
          render={(routeProps) => (
            <GuidedCampaignPayment 
              {...routeProps}
              isOnboarding
              showSuperadminFeatures={false}
              forwardURL={`/welcome/tutorial/${routeProps.match.params.campaignId}/review`}
              backURL={`/welcome/tutorial/${routeProps.match.params.campaignId}/audience`}
            />
          )}
        />
        <Route 
          exact path='/welcome/tutorial/:campaignId/review' 
          render={(routeProps) => (
            <GuidedCampaignReview
              {...routeProps}
              isOnboarding
              showSuperadminFeatures={false}
              forwardURL='/welcome/tutorial/success'
              backURL={`/welcome/tutorial/${routeProps.match.params.campaignId}/payment`}
            />
          )}
        />
      </Switch>
    );
  }
}

OnboardingTutorial.propTypes = {
  //TODO: Fill in prop types for OnboardingTutorial
};

OnboardingTutorial.defaultProps = {
  //TODO: Fill in defaultProps for OnboardingTutorial
};

export default OnboardingTutorial;



// WEBPACK FOOTER //
// ./src/routes/OnboardingTutorial/components/OnboardingTutorial.js